/**
 * 사이트 상태 설정
 * MAINTENANCE_MODE 를 true 로 두면 접속하는 모든 사용자에게
 * 서버 오류 안내 페이지가 표시됩니다.
 * 정상 서비스로 되돌릴 때는 false 로 변경하면 됩니다.
 */
export const MAINTENANCE_MODE = true;

export const MAINTENANCE_INFO = {
  brandName: 'eCashPool',
  errorCode: 'ERR_SERVICE_502',
  supportEmail: 'support@ecashpool-kr.com',
  statusLabel: '서비스 이상 감지',
  headline: '서버에 일시적인 오류가 발생했습니다',
  description:
    '현재 시스템 오류로 인해 웹사이트 접속과 스테이킹 신청이 일시적으로 중단되었습니다. 복구 작업을 진행 중이니 잠시 후 다시 접속해 주세요. 기존 스테이킹 기록과 자산 정보는 안전하게 보관되어 있습니다.',
  panels: [
    {
      icon: 'ri-tools-line',
      label: '현재 상태',
      value: '복구 작업 진행 중',
      caption: '엔지니어링 팀이 원인을 확인하고 있습니다',
    },
    {
      icon: 'ri-error-warning-line',
      label: '영향 범위',
      value: '웹 접속 · 스테이킹 신청',
      caption: '조회된 기존 기록은 영향이 없습니다',
    },
    {
      icon: 'ri-time-line',
      label: '안내 시간',
      value: '2026.10.20 09:20 (KST)',
      caption: '최신 상황은 순차적으로 업데이트됩니다',
    },
  ],
};